import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePages from "./pages/home";
import MembersPage from "./pages/members";
import ProfilePage from "./pages/profile";
import LoginPage from "./pages/login";
import SignInPage from "./pages/signin";
import PricingPlanPage from "./pages/pricingplan";
import ForeZeroPage from "./pages/forezero";
import CommunityPage from "./pages/community";
import BlogPage from "./pages/blog";
import BlogSinglePage from "./pages/blogsingle";
import ContactPage from "./pages/contact";
import ScrollToTop from "./component/layout/scralltop";
import PostPage from "./pages/post";
import PrivateRoute from "./component/auth/PrivateRoute";
import GroupPage from "./pages/group";
import PrivateRouteWithPlan from "./component/auth/PrivateRouteWithPlan";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CustomToast from "./component/CustomToast";
import { Analytics } from "@vercel/analytics/react";

import ChatPage from "./pages/chat";
import GalleryPage from "./pages/gallery";
import PWAInstallModal from "./component/models/pwamodel";
import StoryPage from "./pages/story";
import StoryDetails from "./pages/StoryDetails";

function App() {
  return (
    <div>
      <BrowserRouter>
        <ScrollToTop />
        <PWAInstallModal />

        <CustomToast />

        <Routes>
          <Route path="/" element={<HomePages />} />
          {/* <Route path="profile" element={<ProfilePage />} /> */}
          <Route path="login" element={<LoginPage />} />
          <Route path="signup" element={<SignInPage />} />
          <Route path="pricing" element={<PricingPlanPage />} />
          <Route path="*" element={<ForeZeroPage />} />
          <Route path="blog" element={<BlogPage />} />
          <Route path="blog-single" element={<BlogSinglePage />} />
          <Route path="contact" element={<ContactPage />} />

          <Route path="/profile" element={<ProfilePage />} />

          <Route
            path="/group"
            element={
              <PrivateRouteWithPlan>
                <GroupPage />
              </PrivateRouteWithPlan>
            }
          />

          <Route
            path="members"
            element={
              <PrivateRoute>
                <MembersPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/post"
            element={
              <PrivateRoute>
                <PostPage />
              </PrivateRoute>
            }
          />

          <Route
            path="/gallery"
            element={
              <PrivateRoute>
                <GalleryPage />
              </PrivateRoute>
            }
          />

            <Route
            path="/stories"
            element={
              <PrivateRoute>
                <StoryPage />
              </PrivateRoute>
            }
          />

          <Route
            path="/story-details/:id"
            element={
              <PrivateRoute>
                <StoryDetails />
              </PrivateRoute>
            }
          />

          <Route
            path="community"
            element={
              <PrivateRoute>
                <CommunityPage />
              </PrivateRoute>
            }
          />

          <Route
            path="chat"
            element={
              <PrivateRoute>
                <ChatPage />
              </PrivateRoute>
            }
          />
        </Routes>
      </BrowserRouter>
      <Analytics />
    </div>
  );
}

export default App;
